<!-- Global banner stack — fixed above everything. Its measured height is
     published to --vex-global-banner-height (GlobalBannerOffsetDirective) so the
     toolbar and content are pushed DOWN instead of being covered. Critical
     banners go here, ordered by severity. -->
<div class="global-banner-stack" appGlobalBannerOffset>
  <!-- Impersonation d'abord : l'utilisateur impersonné doit la voir sur toutes les routes. -->
  <app-impersonation-banner></app-impersonation-banner>
  <app-billing-grace-period-banner></app-billing-grace-period-banner>
  <app-email-verification-banner></app-email-verification-banner>
</div>

<!-- Authenticated Loading Screen - Shows for logged-in users during data loading -->
<app-authenticated-loading-screen></app-authenticated-loading-screen>

<!-- Main Application Router -->
<router-outlet></router-outlet>

<!-- Cookie consent banner (Google Consent Mode v2) - prod only, until a choice is made -->
<app-cookie-consent-banner></app-cookie-consent-banner>
